import { convertShippingMethod, convertTaxiShippingQuote } from "./converters";
import { Address, BaseShippingMethodsClient, ShippingMethod, TTaxiShippingQuote } from "@core/types";
import { SupaShippingMethods } from "../types/supabaseFragments";

import { supabaseClient } from "../supabase";

class ShippingMethodsClient extends BaseShippingMethodsClient {
  async getShippingMethods(zoneId?: string, productsWeight?: number): Promise<ShippingMethod[]> {
    if (!zoneId) return [];
    const { data } = await this.instance.get<Record<"shipping_methods", SupaShippingMethods>[]>(
      `/wp-json/wc/v3/shipping/zones/${zoneId}/methods`,
    );

    return data?.length ? data.map(({ shipping_methods }) => convertShippingMethod(shipping_methods)) : [];
  }

  async calculateTaxiShipping(customerAddress: Address): Promise<TTaxiShippingQuote | null> {
    const { data, error } = await supabaseClient.functions.invoke("calculate-taxi-shipping", {
      body: { customerAddress },
    });

    if (error) {
      try {
        const errorBody = await error.context.json();
        throw new Error(errorBody?.error ?? error.message);
      } catch (parseError) {
        if (parseError instanceof Error && parseError.message !== error.message) {
          throw parseError;
        }

        console.error("Error fetching taxi cost:", error);
        throw new Error(error.message);
      }
    }

    return convertTaxiShippingQuote(data);
  }
}

export default ShippingMethodsClient;
